import React, { Fragment } from 'react';

const HotspotsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Hotspots transmit a short and clear message for the user to take action.
          </h1>
        </div>
        <div className="right">
          <p>Similarly to the Banners behavior, Hotspots can be combined with other hotspots or components in order to create compositions that fit the page. Hotspots are contextual and call for the attention of the users, depending on the context of the page.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Elements</h2>
          <p>Each version of the hotspots presented is composed of a set of different elements put together in a specific order. Use the documentation to see what elements compose each one and the differences between each breakpoint.</p>
          <h2 className="h2 page-subtitle">Colours</h2>
          <p>Hotspots have several colour combinations that have been thought and documented. It is up to the designers to make the decision of which colour combination fits the page where the hotspot is being used in.</p>
          <h2 className="h2 page-subtitle">Composition</h2>
          <p>Hotspots can be used together depending on the needs of each page. To get to know all the possible combinations, please consult the documentation where you can find the rules for that.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default HotspotsUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/HotspotsUsage.js